import dictionary from '../translations/dictionary.json';

import { useParams } from "react-router-dom";

function buildLanguageTable(data, lang) {
  const result = {
    
  };

  for (const item of data) {
    for (const key in item) {
        const val = item[key][lang.toUpperCase()];
        if (val !== undefined) {
            result[key] = val;
        } else {
            const alternate_val = item[key]['PL'];
            result[key] = alternate_val;
        }
    }
  }

  return result;
}

export default function useDictionary() {
   
    const params = useParams();


    if (params.lang !== undefined) {
        return buildLanguageTable(dictionary, params.lang);
    } else {
        return buildLanguageTable(dictionary, "PL");
    }

}